


export default function renderDollars(number) {
    number = number === null ? 0 : number
    let prefix = number < 0 ? '-$' : '$'
    return prefix + (number < 0 ? number * -1 : number).toFixed(2)
}